import React from "react";
import { Navigate, useLocation } from "react-router-dom";

type AllowedRole = "transportAdmin" | "student" | "driver";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: AllowedRole[];
}

const roleDashboardMap: Record<string, string> = {
  transportAdmin: "/admin-dashboard",
  student: "/student-dashboard",
  driver: "/driver-dashboard",
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const location = useLocation();
  const token = localStorage.getItem("accessToken");
  const raw = localStorage.getItem("user");

  if (!token || !raw) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  let userRole: string | null = null;
  try {
    const user = JSON.parse(raw);
    userRole = user.role || null;
  } catch {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem("roleData");
    return <Navigate to="/login" replace />;
  }

  if (!userRole || !allowedRoles.includes(userRole as AllowedRole)) {
    const correctDashboard = userRole ? roleDashboardMap[userRole] : null;
    if (correctDashboard) {
      return <Navigate to={correctDashboard} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
